import React, { PropTypes } from 'react'
import StarRating from 'components/StarRating'

import './AliadaBasicInfo.scss'

const buildFullName = ({firstName, lastName}) => {
  return lastName ? `${firstName} ${lastName}` : firstName
}

const AliadaBasicInfo = ({ firstName, lastName, rating, finishedServicesCount, cancellationsCount}) => {
  const fullName = buildFullName({ firstName, lastName })

  const displayName = !!fullName
  const displayRating = typeof rating === 'number' && rating >= 0
  const displayServicesCount = typeof finishedServicesCount === 'number' && finishedServicesCount >= 0
  const displayCancellationsCount = typeof cancellationsCount === 'number' && cancellationsCount >  0

  const cancellationsText = () => {
    if (cancellationsCount === 1) {
      return '1 servicio cancelado recientemente'
    }

    return `${cancellationsCount} servicios cancelados recientemente`
  }

  return (
    <div className='AliadaBasicInfo'>
      {displayName &&
        <p className='AliadaBasicInfo-name'>
          {fullName}
        </p>
      }
      {displayRating &&
        <p className='AliadaBasicInfo-rating'>
          <StarRating value={rating} min={0} max={5} />
        </p>
      }
      {displayServicesCount &&
        <p className='AliadaBasicInfo-servicesCompleted'>
          {finishedServicesCount} servicios prestados
        </p>
      }
      {displayCancellationsCount &&
        <p className='AliadaBasicInfo-cancellations'>
          { cancellationsText() }
        </p>
      }
    </div>
  )
}

AliadaBasicInfo.displayName = 'AliadaBasicInfo'
AliadaBasicInfo.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  rating: PropTypes.number,
  finishedServicesCount: PropTypes.number
}

export default AliadaBasicInfo



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/AliadaBasicInfo/AliadaBasicInfo.js